import React from 'react';
import { XIcon, LayoutIcon, ArrowRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface ComparisonBarProps {
  selectedProducts: any[];
  removeFromComparison: (productId: number) => void;
  clearComparison: () => void;
}
export const ComparisonBar: React.FC<ComparisonBarProps> = ({
  selectedProducts,
  removeFromComparison,
  clearComparison
}) => {
  const navigate = useNavigate();
  if (selectedProducts.length === 0) {
    return null;
  }
  const handleCompare = () => {
    navigate('/compare', {
      state: {
        selectedProducts
      }
    });
  };
  return <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-10" data-id="element-2818">
      <div className="container mx-auto px-4 py-3" data-id="element-2819">
        <div className="flex items-center justify-between" data-id="element-2820">
          <div className="flex items-center" data-id="element-2821">
            <LayoutIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-2822" />
            <span className="font-medium text-gray-800" data-id="element-2823">
              {selectedProducts.length}{' '}
              {selectedProducts.length === 1 ? 'tour' : 'tours'} selected
            </span>
          </div>
          <div className="flex items-center space-x-4" data-id="element-2824">
            <div className="flex space-x-2" data-id="element-2825">
              {selectedProducts.map(product => <div key={product.id} className="flex items-center bg-gray-100 rounded-md px-2 py-1" data-id="element-2826">
                  <span className="text-sm text-gray-800 mr-1 truncate max-w-[120px]" data-id="element-2827">
                    {product.title}
                  </span>
                  <button onClick={() => removeFromComparison(product.id)} className="text-gray-500 hover:text-gray-700" data-id="element-2828">
                    <XIcon className="h-4 w-4" data-id="element-2829" />
                  </button>
                </div>)}
            </div>
            <div className="flex space-x-2" data-id="element-2830">
              <button onClick={clearComparison} className="px-3 py-1.5 border border-gray-300 text-gray-700 rounded-md text-sm hover:bg-gray-50" data-id="element-2831">
                Clear All
              </button>
              <button onClick={handleCompare} disabled={selectedProducts.length < 2} className={`px-3 py-1.5 rounded-md text-sm flex items-center ${selectedProducts.length < 2 ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-blue-600 text-white hover:bg-blue-700'}`} data-id="element-2832">
                Compare
                <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-2833" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};